import { Box, Typography } from '@mui/material';
import type { ReactNode } from 'react';

/** Column template for the read-only registry data grids (Fecha / Producto / Dosis, etc.). */
export const COLUMNS = 'repeat(3, 1fr)';
/** Same three columns plus a trailing 48px action column, used in edit mode. */
export const EDIT_COLUMNS = 'repeat(3, 1fr) 48px';

/**
 * A single cell in a registry data grid. Pass `header` for the column-title styling.
 * Shared by the application, application-report and visit cards.
 */
export const Cell = ({ children, header = false }: { children: ReactNode; header?: boolean }) => (
    <Box sx={{ px: 1.5, py: 1, borderBottom: 1, borderColor: 'primary.mui.stroke' }}>
        <Typography variant={header ? 'caption' : 'body2'} fontWeight={header ? 'bold' : undefined} color='primary'>
            {children}
        </Typography>
    </Box>
);
